import { useTranslation } from 'react-i18next';
import { TranslatedCalling } from './common';

function ImageDetailsResult({ image }: { image: any }) {
  const { t } = useTranslation('chat');
  return (
    <div className="text-xs text-gray-400 font-light flex items-center gap-1">
      <img
        src={image.thumbnailUrl}
        alt={t('tool.fetch-image-details.image-alt', { id: image.id })}
        className="w-10 h-10 rounded-md mr-2"
      />{' '}
      {t('tool.fetch-image-details.fetched-info')}
    </div>
  );
}

export const fetch_image_details = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.fetch-image-details.gathering" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.fetch-image-details.gathering" />,
  result: ({ result: image }: any) => <ImageDetailsResult image={image} />,
};
